import { createSlice } from '@reduxjs/toolkit';

import { AuthTokenState } from './types';

const initialState: AuthTokenState = {
  myDashboardToken: '',
  azureADToken: '',
  refreshToken: '',
};

export const authTokenSlice = createSlice({
  name: 'authTokenSlice',
  initialState,
  reducers: {
    setAuthToken: (state, action) => ({ // access token jwt binus
      myDashboardToken: action.payload,
      refreshToken: state.refreshToken,
      azureADToken: state.azureADToken,
    }),
    setRefreshToken: (state, action) => ({ // refresh token binus
      myDashboardToken: state.myDashboardToken,
      refreshToken: action.payload,
      azureADToken: state.azureADToken,
    }),
    setAuthTokenAzureAD: (state, action) => ({ // access token jwt azure ad
      myDashboardToken: state.myDashboardToken,
      refreshToken: state.refreshToken,
      azureADToken: action.payload,
    }),
  },
});

export const { setAuthToken, setRefreshToken, setAuthTokenAzureAD } = authTokenSlice.actions;
export const authTokenReducer = authTokenSlice.reducer;
